import { logUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';

export type AppHostEntryPoint =
    | 'AccountSwitch'
    | 'ActionableMessages'
    | 'AppBar'
    | 'LaunchPageAppStore'
    | 'AppHostHeader'
    | 'ComposeAppStore'
    | 'DeepLinkService'
    | 'DispatchActionWrapper'
    | 'PageService'
    | 'Routing'
    | 'ToDoListManageTasks'
    | 'NewLargeEventFromMailRibbon'
    | 'NewLargeEventFromCalendarRibbon'
    | 'ToDoContextMenu'
    | 'TaskReminderNotification'
    | 'MyDayHeader'
    | 'VivaEngageEmailNotification'
    | 'Ribbon'
    | 'AddisonReadingPaneIntegration'
    | 'CalendarPeekOthersInOfficeMos'
    | 'OpenVanityDomainNewTab'
    | 'OpenProjectionNewTab'
    | 'CopilotIrisTeachingUI'
    | 'RulesSettings'
    | 'Rewards';

export type AppHostError =
    | 'AppManifest_Null'
    | 'StaticTabs_Empty'
    | 'Unknown'
    | 'Empty_Routing'
    | 'Invalid_Url'
    | AppHostNavigationError;

export enum AppHostNavigationError {
    InvalidAppId = 'Invalid appId.',
    InvalidEntityId = 'Invalid entityId. Default static tab does not have a valid entityId value.',
    AppManifestNotFound = 'App manifest not found in catalog',
    AppManifestWithoutStaticTabs = 'App manifest does not have any static tab defined',
    EntityIdNotFoundInManifest = 'Navigation entityId was not found in app manifest',
}

type NavigateToAppTelemetry = {
    callerFn: AppHostEntryPoint;
    appId: string;
    hasSubEntityId?: boolean;
    appSessionId?: string;
};

type NavigateToAppErrorTelemetry = NavigateToAppTelemetry & {
    error: AppHostError;
};

type OpenUrlNewTabTelemetry = {
    callerFn: AppHostEntryPoint;
    appId: string;
};

export function logError(params: NavigateToAppErrorTelemetry, mailboxInfo: MailboxInfo): void {
    logUsage('AppHost_NavigateToApp_Failure', mailboxInfo, params);
}

export function log(params: NavigateToAppTelemetry, mailboxInfo: MailboxInfo): void {
    logUsage('AppHost_NavigateToApp_Usage', mailboxInfo, params, { isScorecardEvent: true });
}

export function logOpenUrlNewTab(params: OpenUrlNewTabTelemetry, mailboxInfo: MailboxInfo): void {
    logUsage('AppHost_OpenUrlNewTab_Usage', mailboxInfo, params);
}
